import { useEffect } from 'react'

import { useTheme } from 'styled-components'

import { ActionFooter, Box, CircleBackground, Typography } from '@corabank/arco'
import { useDocs, useSteps } from '@Store'

import { UPLOAD_TEXTS } from './constants'
import { DocsForm } from './DocsForm'
import * as Styled from './styles'

const UploadDocsStep = () => {
  const { businessRegistrationTexts, loading, getHasDocs, sendFiles } =
    useDocs()
  const { goStep } = useSteps()
  const { colors } = useTheme()

  const handleSendFilesClick = async (): Promise<void> => {
    mixpanel.track(UPLOAD_TEXTS.BUTTON_METRIC)
    await sendFiles({
      onSuccess: () => goStep(2),
      onError: () => {
        mixpanel.track(UPLOAD_TEXTS.GENERIC_ERROR_METRIC)
      },
    })
  }

  useEffect(() => {
    goStep(1)
    mixpanel.track(UPLOAD_TEXTS.PAGE_VIEW_METRIC)
  }, [])

  return (
    <>
      <Styled.UploadContent
        m="24px auto 0"
        maxWidth="513px"
        minHeight="calc(100vh - 184px)"
      >
        <Typography variant="body2" color="graysGray1" data-testid="page-text">
          {UPLOAD_TEXTS.PAGE_TEXT}
        </Typography>

        <Box mt="16px" maxWidth="500px">
          {UPLOAD_TEXTS.REQUIREMENTS.map((item) => (
            <Box key={item.ID} mb="16px" display="flex" alignItems="center">
              <CircleBackground backgroundColor={colors.softFillsLightInfo}>
                {item.ICON}
              </CircleBackground>
              <Styled.UploadText variant="body2" color="graysGray1">
                {item.LABEL}
              </Styled.UploadText>
            </Box>
          ))}
          <DocsForm />
        </Box>
      </Styled.UploadContent>

      <ActionFooter
        mainAction={{
          disabled: !getHasDocs(),
          label: UPLOAD_TEXTS.BUTTON_LABEL(businessRegistrationTexts),
          loading,
          onClick: handleSendFilesClick,
        }}
        type="onlyButton"
      />
    </>
  )
}

export { UploadDocsStep }
